.ux-iws-nav-login-link {
    &.ux-iws-navigation-meta__item {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            padding: 0;
            margin: 0;
            border: 0;
        }
    }
}
